import React from 'react';
// import { Step } from 'react-joyride';

// Temporary types for React 19 compatibility
// TODO: Replace with types from a React 19 compatible tour library
interface Step {
  target: string;
  content: React.ReactNode;
  title?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  disableBeacon?: boolean;
}

export const overviewTourSteps = [
  {
    target: '[data-tour="waterfall-visibility-toggle"]',
    content: (
      <div>
        <h3>Visibility Toggle</h3>
        <p>
          This toggle controls whether company users can see sections. Click switch to hide or show sections from the
          client&apos;s view.
        </p>
      </div>
    ),
    placement: 'left' as const,
    disableBeacon: true,
  },
] as Step[];
